export default __webpack_public_path__ + "static/media/tongfongfattchicken.f68dde38.jpeg";